import React from "react";
import { View, StyleSheet } from "react-native";
import { ShimmerBox } from "../../components/skeletons";
import StatCardSkeleton from "../../components/adminDashboard/AICompanion/StatCardSkeleton";
import QuickActionButtonSkeleton from "../../components/adminDashboard/QuickActionButton/QuickActionButtonSkeleton";
import CourseHealthCardSkeleton from "../../components/adminDashboard/CourseHealthCard/CourseHealthCardSkeleton";
const SectionLabelSkeleton: React.FC = () => (
  <ShimmerBox width={120} height={12} borderRadius={6} style={{ marginBottom: 16 }} />
);

const AdminDashboardFacultySkeleton: React.FC = () => {
  return (
    <View style={styles.root}>
      {/* ── Header ── */}
      <View style={styles.headerSection}>
        <View style={styles.headerContent}>
          <View style={{ gap: 8 }}>
            <ShimmerBox width={160} height={32} borderRadius={8} />
            <ShimmerBox width={240} height={14} borderRadius={6} />
          </View>
          <View style={{ alignItems: "flex-end", gap: 6 }}>
            <ShimmerBox width={72} height={10} borderRadius={4} />
            <ShimmerBox width={96} height={13} borderRadius={6} />
          </View>
        </View>
      </View>

      {/* ── Stat Cards ── */}
      <View style={styles.statsGrid}>
        <StatCardSkeleton />
        <StatCardSkeleton />
        <StatCardSkeleton />
      </View>

      {/* ── Quick Actions ── */}
      <View style={{ marginBottom: 32 }}>
        <SectionLabelSkeleton />
        <View style={styles.quickActionsRow}>
          <QuickActionButtonSkeleton />
          <QuickActionButtonSkeleton />
          <QuickActionButtonSkeleton />
          <QuickActionButtonSkeleton />
        </View>
      </View>

      {/* ── My Courses ── */}
      <View>
        <SectionLabelSkeleton />
        <View style={styles.coursesGrid}>
          <CourseHealthCardSkeleton />
          <CourseHealthCardSkeleton />
          <CourseHealthCardSkeleton />
          <CourseHealthCardSkeleton />
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  root: {
    flex: 1,
    padding: 32,
    maxWidth: 1280,
    alignSelf: "center",
    width: "100%",
  },
  headerSection: {
    marginBottom: 32,
  },
  headerContent: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  statsGrid: {
    flexDirection: "row",
    gap: 16,
    marginBottom: 32,
  },
  quickActionsRow: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 12,
  },
  coursesGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 16,
  },
});

export default AdminDashboardFacultySkeleton;
